export default "__VITE_ASSET__CA7VNIHQ__"